import { Camera, Shield } from 'lucide-react';

/**
 * ShieldCamera - Displays a shield icon with a camera icon inside
 *
 * Purpose: Reusable component for showing camera-verified photo indicator
 *
 * @param {string} color - Tailwind color class for the icons (default: text-purple-500)
 * @param {number} scale - Scale multiplier for icon sizes (default: 1)
 * @param {string} className - Additional CSS classes for the container
 * @param {string} backgroundColor - Fill color for the shield background (default: #EDE9FE)
 */
function ShieldCamera({ color = 'text-purple-500', scale = 1, className = '', backgroundColor = '#EDE9FE' }) {
  const shieldSize = 32 * scale;
  const cameraSize = 12 * scale;

  return (
    <div className={`relative ${className}`}>
      <Shield size={shieldSize} className={`${color}`} fill={backgroundColor} />
      <Camera size={cameraSize} className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${color} drop-shadow-md`} />
    </div>
  );
}

export default ShieldCamera;
